import home from './home'
import board from './board'
import mypage from './mypage'
import webpart from './webpart'


export default{
    home,
    board,
    mypage,
    webpart
}